import React, {useCallback, useContext, useEffect, useRef, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {AuthContext} from "contexts";
import {PushNotificationSearchParams} from "./PushNotificationsSearchParams";
import {PushNotificationSearchGetParams, SentPushNotification, supportService} from "services/supportService";
import {toDate} from "services";
import {Apps, RootRoutes} from "enums";
import {toDateString} from "utils";

const PAGE = 50

export const PushNotificationsPage = () => {
    const {env} = useContext(AuthContext);
    const [searchParams, setSearchParams] = useSearchParams();

    const [isLoading, setIsLoading] = useState(false);
    const [results, setResults] = useState<SentPushNotification[]>([]);
    const [params, setParams] = useState<PushNotificationSearchGetParams>({
        userKey: searchParams.get('userKey') || '',
        dateFrom: searchParams.get('dateFrom') ? new Date(searchParams.get('dateFrom')!) : null,
        dateTo: searchParams.get('dateTo') ? new Date(searchParams.get('dateTo')!) : null,
        recipientKey: searchParams.get('recipientKey'),
        eventType: searchParams.get('eventType') as any,
        skip: searchParams.get('skip') ? parseInt(searchParams.get('skip')!) : 0,
        take: searchParams.get('take') ? parseInt(searchParams.get('take')!) : PAGE
    });

    const paramsRef = useRef(params);
    useEffect(() => {
        paramsRef.current = params;
    }, [params]);

    const reload = useCallback(async () => {
        if (!env) {
            return;
        }
        setIsLoading(true);
        const response = await supportService.getPushNotifications(env, paramsRef.current);
        response && setResults(response.pushEvents);
        setIsLoading(false);
    }, [env]);

    const handleSearch = async () => {
        if (!env) {
            return;
        }

        // Update URL with current params
        const newParams = new URLSearchParams();
        if (params.userKey) newParams.set('userKey', params.userKey);
        if (params.recipientKey) newParams.set('recipientKey', params.recipientKey);
        if (params.eventType) newParams.set('eventType', params.eventType);
        if (params.dateFrom) newParams.set('dateFrom', params.dateFrom.toISOString());
        if (params.dateTo) newParams.set('dateTo', params.dateTo.toISOString());
        newParams.set('skip', params.skip.toString());
        newParams.set('take', params.take.toString());

        setSearchParams(newParams);
        reload();
    };


    useEffect(() => {
        if (!env) {
            return;
        }


        const hasParams = searchParams.toString();
        if (hasParams) {
            setIsLoading(true);
            supportService.getPushNotifications(env, {
                userKey: searchParams.get('userKey') || '',
                dateFrom: searchParams.get('dateFrom') ? new Date(searchParams.get('dateFrom')!) : null,
                dateTo: searchParams.get('dateTo') ? new Date(searchParams.get('dateTo')!) : null,
                recipientKey: searchParams.get('recipientKey') || undefined,
                eventType: searchParams.get('eventType') as any || undefined,
                skip: searchParams.get('skip') ? parseInt(searchParams.get('skip')!) : 0,
                take: searchParams.get('take') ? parseInt(searchParams.get('take')!) : PAGE
            }).then(response => {
                response && setResults(response.pushEvents);
                setIsLoading(false);
            });
        }
    }, [env]);


    return (
        <div className="d-flex flex-column align-items-center m-2 m-lg-3" style={{maxHeight: '90vh'}}>
            <PushNotificationSearchParams onSearch={handleSearch} params={params} setParams={setParams}/>
            <div className="mt-3">
                {isLoading ? 'Загружается...' : !results.length && 'Результатов нет'}
            </div>
            {!!results.length && (
                <div className="overflow-auto w-100 d-flex flex-column align-items-center mt-2">
                    <div className="w-75">
                        <table className="table table-hover">
                            <thead className="bg-white border-bottom">
                            <tr>
                                <th scope="col">Отправитель</th>
                                <th scope="col">Получатель</th>
                                <th scope="col">Тип</th>
                                <th scope="col">Дата</th>
                            </tr>
                            </thead>
                            <tbody>
                            {results.map((result, index) => {
                                const date = toDate(result.dateSent, env?.app ?? Apps.Instinct)
                                return (
                                    <tr key={index}>
                                        <td>
                                            <a href={`${RootRoutes.Profile}/${result.userKey}`}
                                               target="_blank" rel="noreferrer">{result.userKey}</a>
                                        </td>
                                        <td><a href={`${RootRoutes.Profile}/${result.recipientKey}`}
                                               target="_blank" rel="noreferrer">{result.recipientKey}</a>
                                        </td>
                                        <td>{result.eventType}</td>
                                        <td>{result.dateSent && toDateString(date, true)}</td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};